import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconPointerDown } from '@alfa-bank/site-icon/pointer-down';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';
import { DataLayer } from '@alfa-bank/site-data-layer';

import { BannerLink } from '../banner-link';
import styles from '../../styles/styles.css';

import { ApplicationsButton as Component } from './applications-button';
import type { IDeps, TApplicationsButton } from './models';
import { IconBag } from './icon-bag';

export const ApplicationsButton = createWidget<IDeps, TApplicationsButton>({
    BannerLink,
    Button,
    DataLayer,
    IconPointerDown,
    Tooltip,
    styles,
    IconBag,
})(Component);
